import React, { useId, useRef, useState } from "react";
import { Download } from "lucide-react";
import { getBullseyeRelayRoster } from "../../lib/leaderboardApi";
import "./RelayPdfExport.css";

export default function RelayPdfExport({ match, disabled = false, hasUnsavedChanges = false }) {
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const lock = useRef(false);
  const id = useId();
  async function exportPdf() {
    if (lock.current) return;
    lock.current = true; setBusy(true); setError(""); setMessage("");
    try {
      // Read again on export so saved device/web changes are not omitted from a stale screen.
      const [roster, { downloadRelayPdf }] = await Promise.all([
        getBullseyeRelayRoster(match.matchId), import("../../lib/bullseyeRelayPdf"),
      ]);
      if (!roster.competitors.length) { setMessage("No confirmed competitors are available to export yet."); return; }
      await downloadRelayPdf({ match, roster });
      setMessage("PDF ready. Check your downloads.");
    } catch { setError("Couldn't export the PDF. Please try again."); }
    finally { lock.current = false; setBusy(false); }
  }
  return <div className="relay-pdf-export">
    <button type="button" className="relay-pdf-button" onClick={exportPdf} disabled={disabled || busy || hasUnsavedChanges} aria-describedby={`${id}-hint`} aria-busy={busy}>
      <Download size={17} aria-hidden="true" />{busy ? "Preparing PDF…" : "Download Relay PDF"}
    </button>
    <small id={`${id}-hint`}>{hasUnsavedChanges ? "Save or discard your edits before exporting." : "All relays · Confirmed competitors"}</small>
    {message && <span role="status">{message}</span>}
    {error && <span role="alert">{error}</span>}
  </div>;
}
